import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: boolean = false

const loadingSlice = createSlice({
    name: 'loading-slice',
    initialState,
    reducers: {
        setIsLoading: (state, action: PayloadAction<boolean>) => {
            return state = action.payload;
        }
    },
})

export default loadingSlice;